import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'text-question',
  templateUrl: './text-question.component.html',
  styleUrls: ['./text-question.component.less']
})
export class TextQuestionComponent implements OnInit {
  @Input() question: any;
  @Output() answered: EventEmitter<any> = new EventEmitter();
  @Output() answerCleared: EventEmitter<any> = new EventEmitter();
  @Output() modified: EventEmitter<any> = new EventEmitter();
  hasAnswer: boolean = false;

  ngOnInit() {
    if (this.question.rows[0].value)
      this.hasAnswer = true;
  }

  checkAnswered() {
    if (this.question.rows[0].value && !this.hasAnswer) {
      this.hasAnswer = true;
      this.answered.emit(null);
    }

    if (!this.question.rows[0].value && this.hasAnswer) {
      this.hasAnswer = false;
      this.answerCleared.emit(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/survey/text-question/text-question.component.ts